module.exports = __webpack_public_path__ + "img/banner-new-Info.aecfa61e.png";